module.exports = __webpack_public_path__ + "img/61200.d992cd24.jpg";